export default "__VITE_ASSET__e904de28__"